

















import Vue from 'vue'
import { BlockStatusElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'BlockStatusEl',
  props: {
    templateItemData: {
      type: Object as () => BlockStatusElInterface,
      required: true
    }
  }
})
